import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import TrackingNumberColumn from '../../../components/columns/tracking-number-column';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

import style from './style.module.less';

const TrackingNumberColumnComponent = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) return '';

  const { returnStatus, trackingInformation } = ret || {};
  const isVoided = returnStatus === 'Voided';
  const trackingSummary = trackingInformation
    ? {
        trackingNumber: trackingInformation.trackingNumber,
        url: trackingInformation.url,
        status: trackingInformation.status,
      }
    : null;

  return (
    <div className={classNames({ [style['voided-tracking-number']]: isVoided })}>
      <TrackingNumberColumn shouldRenderIcon={!isVoided} trackingSummary={trackingSummary} />
    </div>
  );
};

export const TrackingNumber = {
  getMessageDescriptor: () => messages.trackingNumber,
  id: 'tracking-number',

  render: ({ fulfillmentId }) => {
    return <TrackingNumberColumnComponent fulfillmentId={fulfillmentId} />;
  },
};
